import React, {Component} from 'react';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import DataFetcher from '../utils/DataFetcher';

const history = require("history").createHashHistory()

class Redirect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading'
        }
    }

    componentDidMount() {
        this.code = CommonUtils.resolveSearchParam(this.props.location, 'code');
        this.redirectDest = CommonUtils.resolveSearchParam(this.props.location, 'state');

        DataFetcher.login({
            code: this.code
        }, {
            success: (resp) => {
                if(this.redirectDest === 'agent') {
                    history.replace('/agent')
                } else if(this.redirectDest === 'user') {
                    history.replace('/user')
                } else if(this.redirectDest === 'about') {
                    history.replace('/about')
                } else if(this.redirectDest === 'coupon') {
                    history.replace('/user/coupon')
                } else if(this.redirectDest === 'operator') {
                    history.replace('/operator/coupon')
                } else if(this.redirectDest === 'gameRank') {
                    history.replace('/rank/game')
                } else if(this.redirectDest === 'kf') {
                    history.replace('/kf')
                } else {
                    this.setState({
                        status: 'nopage'
                    })
                }
            },
            logicError: () => {
                this.setState({
                    status: 'noauth'
                })
            },
            sysError: () => {
                this.setState({
                    status: 'noauth'
                })
            }
        })
    }

    render() {
        const {status} = this.state;

        if (status === 'noauth') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={Constants.Strings.NO_AUTH}/>;
        } else if (status === 'nopage') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={Constants.Strings.NO_PAGE}/>;
        } else {
            return <LoadingPlaceholder/>;
        }
    }
}

export default Redirect;


// WEBPACK FOOTER //
// ./src/modules/Redirect.js